import { render, staticRenderFns } from "./ListDetail.vue?vue&type=template&id=2f1000ba&scoped=true&"
import script from "./ListDetail.vue?vue&type=script&lang=js&"
export * from "./ListDetail.vue?vue&type=script&lang=js&"
import style0 from "./ListDetail.vue?vue&type=style&index=0&id=2f1000ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1000ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1000ba')) {
      api.createRecord('2f1000ba', component.options)
    } else {
      api.reload('2f1000ba', component.options)
    }
    module.hot.accept("./ListDetail.vue?vue&type=template&id=2f1000ba&scoped=true&", function () {
      api.rerender('2f1000ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Doc/ListDetail.vue"
export default component.exports